var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class SlideDown extends Component {
    constructor() {
        super('Menu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-slide-down-toggle').each((button) => {
                button.on('click', (event) => {
                    event.preventDefault();
                    let timeout = 0;
                    if (button.hasClass('is-expanded')) {
                        $.scrollTo(button.parents('.box').position().y - $('header').height(), 250);
                        timeout = 750;
                    }
                    setTimeout(() => {
                        button.toggleClass('is-expanded');
                        button.find('.triangle').toggleClass('triangle-top triangle-bottom');
                        Slider.toggle($(button.data('target')));
                    }, timeout);
                });
            });
            $('.btn-slide-down-toggle-next').each((button) => {
                button.on('click', (event) => {
                    event.preventDefault();
                    button.find('.triangle').toggleClass('triangle-top triangle-bottom');
                    Slider.toggle(button.next());
                });
            });
            this.success();
        });
    }
}
export class Slider {
    static open(element, ignoreParents = false) {
        Slider.computeHeight(element);
        if (!ignoreParents)
            Slider.computeParentsHeight(element);
    }
    static close(element, ignoreParents = false) {
        let maxHeight = element.parents('.note').length > 0 ? 80 : 0;
        element.css('max-height', maxHeight.toString() + 'px');
        if (!ignoreParents)
            Slider.computeParentsHeight(element);
    }
    static toggle(element, ignoreParents = false) {
        let maxHeight = element.parents('.note').length > 0 ? 80 : 0;
        if (parseInt(element.css('max-height')) == maxHeight) {
            Slider.open(element, ignoreParents);
        }
        else {
            Slider.close(element, ignoreParents);
        }
    }
    static computeHeight(element) {
        let contentHeight = element.find('.slide-down-content').first().height();
        element.css('max-height', contentHeight + 'px');
    }
    static computeParentsHeight(element) {
        let startTime = (new Date()).getTime();
        let interval = setInterval(() => {
            element.parents('.slide-down:not(.slide-down-ignore-children)').each((slideDown) => {
                Slider.computeHeight(slideDown);
            });
            if ((new Date()).getTime() - startTime > 500)
                clearInterval(interval);
        }, 40);
    }
}
